import { module } from 'modujs';
import gsap from "gsap";
import { onWidthResize } from '../utils/tickers';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                more: 'showMore'
            }
        }
    }

    init() {
        this.el.querySelectorAll('[data-collapse]').forEach((collapse) => {
            const collapseToggle = collapse.querySelector('[data-collapse-toggle]');
            const collapseContent = collapse.querySelector('[data-collapse-content]');
            const collapseContentInner = collapse.querySelector('[data-collapse-content-inner]');

            if (!collapseToggle || !collapseContent || !collapseContentInner) {
                return;
            }

            collapseToggle.addEventListener('click', () => {
                const contentHeight = collapseContentInner.offsetHeight;
                collapse.toggleAttribute('data-collapse-opened');
                gsap.to(collapseContent, {
                    height: collapse.hasAttribute('data-collapse-opened') ? contentHeight : 0,
                    ease: 'expo.out',
                    duration: 0.8,
                    onComplete: () => {
                        this.call('resize', 'Scroll');
                    }
                });
            });
        });

        onWidthResize(() => {
            this.resizeCollapsesContents()
        });
    }

    resizeCollapsesContents() {
        this.el.querySelectorAll('[data-collapse-opened]').forEach((collapse) => {
            const collapseContentInner = collapse.querySelector('[data-collapse-content-inner]');
            const collapseContent = collapse.querySelector('[data-collapse-content]');

            if (!collapseContentInner || !collapseContent) {
                return;
            }

            collapseContent.style.height = collapseContentInner.offsetHeight + 'px';
        });
    };

    showMore() {
        this.el.querySelector('.c-faqs_more').classList.add('-hidden');
        
        if (this.el.querySelectorAll('.c-faq.-hidden')) {
            this.el.querySelectorAll('.c-faq.-hidden').forEach((faq, index) => {
                faq.classList.remove('-hidden');
                setTimeout(() => {
                    faq.classList.add('is-inview');
                }, index * 100);
            });
        }
    }
}
